module.exports = __webpack_public_path__ + "img/Close - Blue.28d6758d.png";